import * as api from "../../apis/consignOrder";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Link, useHistory} from "react-router-dom";
import useAntTable from "../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import dayjs from "dayjs";
import {ConsignmentOrderStatusMapping, LogType, PresaleOrderStatusMapping} from "../../utils/constants";
import {Button, Space} from "antd";
import Divider from "../../components/Divider";
import LogModal from "../../components/LogModal";
import {useState} from "react";
import {useRequest} from "ahooks";
import OrderContactModal from "../../components/OrderContactModal";
import withAuth from "../../utils/withAuth";

const ContactButton = withAuth('contact', Button);
const ExportOrderButton = withAuth('exportOrder', Button);


function ConsignOrder(props: any) {
    const history = useHistory();
    const {tableProps, refresh, form, search, download, downloading} = useAntTable(api.getOrders, {
        method: 'post',
        downloadUrl: api.exportOrderUrl
    });

    const [contactOrder, setContactOrder] = useState<number | string>();

    const {loading: loadingContact, run: runContact} = useRequest(api.contactOrder, {
        manual: true,
        onSuccess(res) {
            setContactOrder(undefined);
            refresh();
        }
    })


    const columns: StandardColumnsType = [
        {
            dataIndex: 'code',
            title: '寄售申请单号'
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称'
        },
        {
            dataIndex: 'orderDate',
            title: '订单日期',
            render(v) {
                return dayjs(v).format('ll')
            }
        },
        {
            dataIndex: 'status',
            title: '状态',
            render(v) {
                return ConsignmentOrderStatusMapping[v];
            }
        },
        {
            dataIndex: 'productTotalAmount',
            title: '订单合计'
        },
        {
            dataIndex: 'contacted',
            title: '已联系',
            render(v, record: any) {
                return v ? '是' : '否'
            }
        },
        {
            dataIndex: 'operation',
            title: '操作',
            render(_, record: any) {
                return <Divider>
                    <Link to={`/order/consign/detail/${record.id}`}>详情</Link>
                    <Button type={"link"}
                            onClick={() => LogModal.open(LogType.ConsignmentOrder, record.id)}>日志</Button>
                    <ContactButton type={"link"} onClick={() => handleContact(record)}>联系</ContactButton>
                </Divider>
            }
        }
    ];
    const searchColumns: StandardColumnsType = [
        {
            dataIndex: 'code',
            title: '寄售申请单号',
            search: true
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称',
            search: true
        },
        {
            dataIndex: 'orderDateRange',
            title: '订单日期',
            search: {
                valueType: 'dateRange'
            }
        },
    ];

    const handleContact = (record: any) => {
        setContactOrder(record.id);
    }

    const finishContact = (values: any) => {
        runContact(values);
    }

    const toolbar = (
        <Space>
            <ExportOrderButton type={"primary"} loading={downloading}
                               onClick={download}>订单列表导出</ExportOrderButton>
        </Space>
    )


    return <PageHeaderLayout>
        <StandardTable {...tableProps} form={form} columns={columns} search={search} extSearchColumns={searchColumns}
                       toolbar={toolbar}/>
        <OrderContactModal contactOrderId={contactOrder} onCancel={() => setContactOrder(undefined)}
                           onComplete={finishContact} destroyOnClose/>

    </PageHeaderLayout>
};

export default ConsignOrder;
